import React, { useState } from 'react';
import { Card, Image } from 'react-bootstrap';
import { Container, Col, Row, Button, Modal } from 'react-bootstrap';
import './Publications.css';

export const Publications = () => {

    /**********************************************
       HARDCODED PUBLICATIONS DATA
     **********************************************/
    const publications = [
        {
            id: 1,
            title: "Grandma's Burial",
            desc: "",
            //category: "",
            date: "June 2026",
            flipbook_url: "https://heyzine.com/flip-book/741b8b8b36.html"
        },
        {
            id: 2,
            title: "Grandma's Burial",
            desc: "",
            //category: "",
            date: "June 2026",
            flipbook_url: "https://heyzine.com/flip-book/741b8b8b36.html"
        },
        {
            id: 3,
            title: "Grandma's Burial",
            desc: "",
            //category: "",
            date: "June 2026",
            flipbook_url: "https://heyzine.com/flip-book/741b8b8b36.html"
        },
 
    ];


    /**********************************************
       FLIPBOOK MODAL
     **********************************************/
    const [showModal, setShowModal] = useState(false);
    const [activeFlipbook, setActiveFlipbook] = useState({ title: '', url: '' });

    const openFlipbook = (title, url) => {
        setActiveFlipbook({ title, url });
        setShowModal(true);
    };

    const closeFlipbook = () => {
        setShowModal(false);
        setActiveFlipbook({ title: '', url: '' });
    };


    return (
        <div>

            {/* PAGE BANNER */}
            <div>
                <div style={{ position: 'relative' }}>
                    <Image fluid src="images/headerbanner.png" alt="Publications" id="bannerimg" />
                    <div id="banneroverlay">
                        <div id="bannerid" className='text-center'>
                            <h4>PUBLICATIONS</h4>
                        </div>
                    </div>
                </div>
            </div>

            <br></br><br></br>

            <Container>
                <Row>
                    <Col md={12} className='text-center'>
                        <h4 id="bluecolor">Our Digital Publications</h4>
                        <hr style={{ borderTop: '2px solid red', width: '10%', margin: 'auto' }} />
                        <br />
                        <p>
                            Explore our collection of digital magazines, bulletins, and program books —
                            faith-filled resources to keep you informed, inspired, and connected.
                        </p>
                    </Col>
                </Row>

                <br></br><br></br>

                <Row>
                    {
                        publications.map((pub) => {
                            return (
                                <Col md={4} key={pub.id}>
                                    <Card id="publicationcard" className='deptslide'>

                                        {/* FLIPBOOK PREVIEW — static thumbnail */}
                                        <div id="pub-preview-wrapper">
                                            <iframe
                                                src={pub.flipbook_url}
                                                title={pub.title}
                                            />
                                        </div>

                                        <Card.Body className='text-center'>

                                            <span className='pub-tag'>{pub.category}</span>

                                            <Card.Title>
                                                <h6 id="bluecolor">{pub.title}</h6>
                                            </Card.Title>

                                            <p style={{ color: '#000' }}>
                                                {pub.desc}
                                            </p>

                                            <Card.Text style={{ display: 'block' }}>
                                                <p>
                                                    <Button style={{ backgroundColor: '#204782', border: 'none', borderRadius: '0', fontWeight: '600', fontSize: '12px' }}>
                                                        {pub.date}
                                                    </Button>
                                                </p>
                                            </Card.Text>

                                            <Button
                                                style={{ backgroundColor: 'red', border: 'none', borderRadius: '0', fontWeight: '700', fontSize: '13px' }}
                                                onClick={() => openFlipbook(pub.title, pub.flipbook_url)}
                                            >
                                                READ PUBLICATION
                                            </Button>

                                        </Card.Body>
                                    </Card>
                                    <br></br>
                                </Col>
                            );
                        })
                    }
                </Row>
            </Container>

            <br></br><br></br>


            {/* FLIPBOOK MODAL */}
            <Modal
                show={showModal}
                onHide={closeFlipbook}
                size="xl"
                centered
                fullscreen="lg-down"
            >
                <Modal.Header closeButton style={{ backgroundColor: '#204782', color: '#fff' }}>
                    <Modal.Title style={{ fontSize: '16px', fontWeight: '700' }}>
                        {activeFlipbook.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: 0, backgroundColor: '#000' }}>
                    <div id="pub-modal-wrapper">
                        {showModal && (
                            <iframe
                                src={activeFlipbook.url}
                                allowFullScreen
                                title={activeFlipbook.title}
                            />
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ backgroundColor: '#204782' }}>
                    <Button
                        style={{ backgroundColor: 'red', border: 'none', borderRadius: '0', fontWeight: '700' }}
                        onClick={closeFlipbook}
                    >
                        CLOSE
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};